import { useState } from 'react';

const MAX_FREELANCE = 50;
const MIN_FREELANCE = 0;

function useForm (initialData = {}, onSave) {
  const [data, _setData] = useState(initialData);
  const [errors, setErrors] = useState([]);
  const [enableAutoSave, setEnableAutoSave] = useState(true);
  const bind = (name) => {
    const error = errors.find(err => err.name === name);
    const props = {};
    if (name === 'start_month' || name === 'end_month') {
      props.placeholder = 'Month';
      props.className = data[name] ? '' : 'show-placeholder';
    } else if (name === 'start_year' || name === 'end_year') {
      props.placeholder = 'Year';
      props.className = data[name] ? '' : 'show-placeholder';
    } else if (name === 'certification_type_id') {
      props.placeholder = 'Select a Certificate';
      props.className = data[name] ? '' : 'show-placeholder';
    } else if (name === 'sd_issue_year') {
      props.placeholder = 'Year';
      props.className = data[name] ? '' : 'show-placeholder';
    }

    return {
      ...props,
      value: data[name] || '',
      help: error ? error.message : null,
      hasFeedback: !!error,
      validateStatus: error ? 'error' : '',
      onChange: e => {
        let val = e;
        if (e && typeof e === 'object' && 'target' in e) {
          val = e.target.value || '';
        }
        if (name === 'outcome') {
          if (`${val}`.trim() === '<br>') {
            val = '';
          }
        }
        if (name === 'freelance_work_experience_years') {
          if (val !== '') {
            if (val > MAX_FREELANCE) val = MAX_FREELANCE;
            if (val < MIN_FREELANCE) val = MIN_FREELANCE;
          }
        }
        setValue(name, val);
        if (error) resetError(name);
      }
    };
  };

  const bindCheckbox = (name, { reversed } = {}) => {
    return {
      checked: reversed ? !data[name] : !!data[name],
      onChange: e => {
        const value = e && e.target ? e.target.checked : false;
        setValue(name, reversed ? !value : value);
      }
    };
  };

  const bindFile = (name) => {
    return {
      fileList: data[name] || [],
      onChange: e => {
        const value = e && e.target ? e.target.fileList : [];
        setValue(name, value);
      }
    };
  };

  const setError = (name, message) => {
    setErrors(list => [...list.filter(err => err.name !== name), { name, message }]);
  };

  const resetError = (name) => {
    if (!name) setErrors([]);
    setErrors(list => list.filter(err => err.name !== name));
  };

  const setValue = (name, value, disableAutoSave = false) => {
    _setData(d => ({ ...d, [name]: value }));
    if (onSave && !disableAutoSave && enableAutoSave) onSave();
  };

  const getData = () => {
    return new Promise((resolve) => {
      _setData(d => {
        resolve(d);
        return d;
      });
    });
  };

  const getErrors = () => {
    return new Promise((resolve) => {
      setErrors(err => {
        resolve(err);
        return err;
      });
    });
  };

  const setData = (data = {}) => {
    return _setData(d => ({ ...d, ...data }));
  };

  const getChanges = async (data = {}, fields = []) => {
    const _data = await getData();
    return fields.filter(field => {
      if (data[field] !== _data[field]) {
        if (field === 'skills' && Array.isArray(data[field]) && Array.isArray(_data[field])) {
          const list1 = data[field].map(elm => parseInt(elm.skill_id)).sort().join(';');
          const list2 = _data[field].map(elm => parseInt(elm.skill_id)).sort().join(';');
          if (list1 === list2) return false;
        }
        if (Array.isArray(data[field]) && Array.isArray(_data[field])) {
          if (data[field].length === 0 && _data[field].length === 0) {
            return false;
          }
        }
        return true;
      }
      return false;
    });
  };

  const acceptChanges = async (data = {}, fields = []) => {
    const _data = await getData();
    fields.forEach(field => {
      Object.assign(data, { [field]: _data[field] });
    });
  };

  return { data, setData, getData, getErrors, bind, bindFile, bindCheckbox, setValue, getChanges, acceptChanges, setError, resetError, errors, setEnableAutoSave, isValid: !errors.length };
}

export default useForm;
